// Bültenin sabit başvuru tabloları: pist rengi ve at donanımı (jewelry) kısaltmaları.
// State değil - hiç değişmiyorlar, o yüzden store'da değil burada duruyorlar.

export const courseColors: any = {
    'Çim': '#3F8E2B',
    'Kum': '#F79009',
    'Sentetik': '#5C4033',
    'TAPETA': '#D83131',
}


export const jewelryMapping: any = {
    'KG': `Kapalı Gözlük takılacağını ifade eder.`,
    'YP': `Yanak Peluşu takılacağını ifade eder.`,
    'ÖG': `Start makinasına önden giriş yapacağını ifade eder.`,
    'KUL': `Kulaklık takılacağını ifade eder.`,
    'K': `Kulaklık takılacağını ifade eder.`,
    'DB': `Dilinin Bağlanacağını ifade eder.`,
    'SKG': `Ring mahalinden Start'a Kadar Kapalı Gözlük ile geleceğini ifade eder.`,
    'SK': `Ring mahalinden Start'a Kadar Kapalı Gözlük ile geleceğini ifade eder.`,
    'SKUL': `Ring mahalinden Start'a Kadar Kulaklık ile geleceğini ifade eder.`,
    'SGK': `Ring mahalinden Start'a Kadar Gözleri Kapalı geleceğini ifade eder.`,
    'MBH': `Bir atın koşuya müşterek bahis harici olarak katıldığını ifade eder.`,
    'DS': `Komiserler Kararı ile atın Dış Start kullanılacağını ifade eder.`,
    'BB': `Burun Bandı takılacağını ifade eder.`,
    'GKR': `Göz Koruyucu takılacağını ifade eder.`,
    'AP': `Ata aprantinin (jokey yamağı) bineceğini ifade eder.`,
    'EKÜRİ': `Ahırdaş olduğu önceden ilan edilen ve aynı koşuya katılan atların jokeyleri aynı tip forma giyerler numarası büyük olan jokeyi bant takar.`,
    'KGS': `Koşmadığı gün sayısını ifade eder.`,
    'G.ÇIK.': `Geç çıkışı ifade eder.`,
    'EİD': `En iyi derece alanı o safkanın aynı tür pistte ve aynı mesafede yaptığı en iyi dereceyi gösterir. Safkan daha önce aynı tür pistte ve aynı mesafede koşmamışsa bu alanda veri olmaz. Örneğin; safkanın koşacağı programdaki koşu 1.500 metre çim koşusu ise, en iyi derece alanı o güne kadar o atın 1.500 m. çim pist koşusunda yaptığı en iyi dereceyi gösterir. Safkan o güne kadar 1500 m çim pistte hiç koşmamışsa bu alan boş olur.`,
    'S20': `Yarış hayatı boyunca son koştuğu 20 koşuda; En az bir birincilik, Veya en az iki ikincilik, Ya da dört adet tabela(2.lik, 3.lük, 4.lük ),Yapamamış olan atlar hiçbir hipodromdaki koşulara iştirak edemezler (Mahalli koşular hariç).Bu atların ahır tahsisi iptal edilir.(31.12.2009 tarihi itibarı ile 2009 Yılı At Yarışları Genel Hükümleri 13/b maddesine göre koşulara katılma hakkını kaybeden atlar bu hükümden yararlanamazlar.)Ancak yarış hayatı boyunca; Bir G1,veya iki G2, veya dört G3, veya bir G2 ve iki G3, Kazanan atlar için bu kural uygulanmaz. (KV 10 veya A3 koşusu kazanan atlar G3 koşusu kazanmış gibi, KV 11 veya A2 koşusu kazanan atlar G2 koşusu kazanmış gibi işlem görürler.)`
}
